module.exports = __webpack_public_path__ + "static/snow-accumulation-legend-cm-6e3125fa89e098c18aebe2ffaf5d8e4e.svg";